export default __webpack_public_path__ + "static/media/pavithara-h.8a247395.jpeg";